import React, { lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import ColorPage from "./pages/ColorPage";
import InventoryPage from "./pages/InventoryPage";
import CheckOutPage from "./pages/CheckOutPage";
import ModalsPage from "./pages/ModalsPage";
import { Toaster } from "react-hot-toast";
import CartSummary from "./pages/CartSummary";
import OrderPage from "./pages/OrderPage";
import SavedPayment from "./pages/SavedPayment";
import SavedAddress from "./pages/SavedAddress";
import MyEarning from "./pages/MyEarning";
import AtYourDoorStore from "./pages/AtYourDoorStore";
import EarnAndReferPage from "./pages/EarnAndReferPage";
import OrderDetails from "./pages/OrderDetails";
import ProtectedRoute from "./middleware/ProtectedRoute";
import BrandsPage from "./pages/BrandsPage";
const Homepage = lazy(() => import("./pages/Homepage"));
const Servicepage = lazy(() => import("./pages/Servicepage"));
const Contactpage = lazy(() => import("./pages/Contactpage"));
const BookARepairPage = lazy(() => import("./pages/BookARepairPage"));
const TermConditionPage = lazy(() => import("./pages/TermCoditionPage"));
const BlogsPage = lazy(() => import("./pages/BlogsPage"));
const AboutUsPage = lazy(() => import("./pages/AboutUsPage"));
const RefundPolicyPage = lazy(() => import("./pages/RefundPolicyPage"));
const GDPRPolicyPage = lazy(() => import("./pages/GDPRPolicyPage"));
const FaqsPage = lazy(() => import("./pages/FaqsPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const ConfirmPage = lazy(() => import("./pages/OrderConfirmationPage"));

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
};

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 2000,
            style: {
              background: "#73b734", 
              color: "#fff",
            },
            success: {
              style: {
                background: "#73b734", 
                color: "#fff",
              },
            },
            error: {
              style: {
                background: "#ff4d4d", 
                color: "#fff",
              },
            },
          }}
        />


        <ScrollToTop /> 

        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/aboutus" element={<AboutUsPage />} />
          <Route path="/service" element={<Servicepage />} />
          <Route path="/contact" element={<Contactpage />} />
          <Route path="/blog" element={<BlogsPage />} />
          <Route path="/book-a-repair" element={<BookARepairPage />} />
          {/* <Route path="/at-your-door-store" element={<TrackMyRepairPage />} /> */}
          <Route path="/term-condition" element={<TermConditionPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/gdpr-policy" element={<GDPRPolicyPage />} />
          <Route path="/faqs" element={<FaqsPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/brands/:token" element={<ModalsPage />} />
          <Route path="/brands/:b_token/:model_token" element={<ColorPage />} />
          <Route path="/inventory/:brand_token/:model_token" element={<InventoryPage />} />
          <Route path="/checkout" element={<CheckOutPage />} />
          <Route path="/cart-summary/:brand_token/:model_token" element={<CartSummary />} />
          <Route path="/confirm-order/:id" element={<ConfirmPage />} />
          <Route path="/order" element={<ProtectedRoute><OrderPage /></ProtectedRoute>} />
          <Route path="/saved-payment" element={<ProtectedRoute><SavedPayment /></ProtectedRoute>} />
          <Route path="/saved-address" element={<ProtectedRoute><SavedAddress /></ProtectedRoute>} />
          <Route path="/my-earning" element={<ProtectedRoute><MyEarning /></ProtectedRoute>} />
          <Route path="/at-your-door-store" element={<AtYourDoorStore />} />
          <Route path="/earn-and-refer" element={<ProtectedRoute><EarnAndReferPage /></ProtectedRoute>} />
          <Route path="/order-details/:order_token" element={<OrderDetails  />} />
         


        </Routes>
      </BrowserRouter>

    </>
  );
};

export default App;
